import { render, staticRenderFns } from "./JRD.vue?vue&type=template&id=2343de4c"
import script from "./JRD.vue?vue&type=script&lang=js"
export * from "./JRD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports